import { JSFSelect, JSFSelectUncontrolled } from '~/components/jsonschema/VndlyJsonSchemaFormBase/widgets/select'

export const LocaleSelect = ({ id, name, value, initialValue, onChange, isUncontrolled = false }) => {
  const JSFSelectComponent = isUncontrolled ? JSFSelectUncontrolled : JSFSelect
  const valueProps = isUncontrolled ? { initialValue } : { value }
  return (
    <JSFSelectComponent
      id={id}
      name={name}
      {...valueProps}
      options={{
        preloadFromApi: {
          url: '/api/v2/l10n/locale/options/'
        }
      }}
      onChange={onChange}
    />
  )
}
